import { css } from 'lit';

export default [
  css`
  :host {
    color: var(--tenable-form-error-color, #e24301);
    font-size: var(--tenable-form-error-font-size, 100%);
  }`,
];
